import { MaterialType } from "pages/MaterialSpecs/components";

interface LocaleMap {
    [key: string]: string | undefined;
}

const localeFormatDateTimeMap: LocaleMap = {
    "en-US": "MM/dd/yyyy HH:mm",
    "pl-PL": "dd/MM/yyyy HH:mm",
};

const localeFormatDateMap: LocaleMap = {
    "en-US": "MM/dd/yyyy",
    "pl-PL": "dd/MM/yyyy",
};

const SHOW_WELCOME_TAB = "SHOW_WELCOME_TAB";

export const ACCESS_TOKEN_KEY = "accessToken";

export const isTestingEnv = process.env.NODE_ENV === "test";

export const isDevEnv = process.env.NODE_ENV === "development";

export const isProdEnv = process.env.NODE_ENV === "production";

// eslint-disable-next-line
export const isPlainObject = (obj: any): boolean => {
    return Object.prototype.toString.call(obj) === "[object Object]";
};

export const getLocalStorageAccessToken = () => localStorage.getItem(ACCESS_TOKEN_KEY);

export const removeLocalStorageAccessToken = () => localStorage.removeItem(ACCESS_TOKEN_KEY);

export const setLocalStorageAccessToken = (accessToken: string) => localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);

export const serverAddress = process.env.REACT_APP_SERVER_ADDRESS || "";

//eslint-disable-next-line
export const isAtLeastOneArgumentNotEmpty = (...args: any): boolean =>
    //eslint-disable-next-line
    !!args.find((arg: any) => arg !== undefined && arg !== null && arg !== "");

export const isEmpty = (obj: object) => {
    return Object.keys(obj).length === 0 && obj.constructor === Object;
};

export const getUrlParam = (param: string) => new URLSearchParams(window.location.search).get(param);

export const USERS_SET_LANGUAGE = "i18nextLng";

export const replaceArrayItem = <T>(array: T[], index: number, item: T) => {
    return [...array.slice(0, index), { ...item }, ...array.slice(index + 1)];
};

export const getLocale = () =>
    navigator.languages && navigator.languages.length ? navigator.languages[0] : navigator.language;

export const capitalize = (s: string) => {
    return s.charAt(0).toUpperCase() + s.slice(1);
};

export const isElementInViewport = ({ top, left, bottom, right }: DOMRect) => {
    return (
        top >= 0 &&
        left >= 0 &&
        bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        right <= (window.innerWidth || document.documentElement.clientWidth)
    );
};

export const millisecondsToSeconds = (milliSeconds: number) => milliSeconds * 0.001;

export const secondsToMilliseconds = (seconds: number) => seconds * 1000;

// todo: take care of magic numbers
export const toHHMMSS = (seconds: number) => {
    const appendZeroIfNeeded = (num: number) => (num < 10 ? `0${num}` : `${num}`);

    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds - hours * 3600) / 60);
    const formattedSeconds = Math.floor(seconds - hours * 3600 - minutes * 60);

    const time = `${appendZeroIfNeeded(minutes)}:${appendZeroIfNeeded(formattedSeconds)}`;

    return hours === 0 ? time : `${appendZeroIfNeeded(hours)}:${time}`;
};

export const getLocaleDateTimeFormat = () => localeFormatDateTimeMap[getLocale()] || "dd/MM/yyyy HH:mm";

export const getLocaleDateFormat = () => localeFormatDateMap[getLocale()] || "dd/MM/yyyy";

export const getLocalStorageIsDoNotShowWelcomeTab = () => {
    const value = localStorage.getItem(SHOW_WELCOME_TAB);

    return value ? JSON.parse(value) : false;
};

export const setLocalStorageDoNotShowWelcomeTab = (showWelcomeTab: boolean) =>
    localStorage.setItem(SHOW_WELCOME_TAB, JSON.stringify(showWelcomeTab));

export const isIFrame = window.location !== window.parent.location;

export const getMaterialType = (format = ""): MaterialType => {
    switch (format.toUpperCase()) {
        case "MP4":
        case "WEBM":
            return "VIDEO";
        case "JPG":
        case "JPEG":
        case "PNG":
        case "GIF":
            return "IMAGE";
        case "HTML":
            return "HTML";
        case "PDF":
            return "PDF";
        case "EPS":
            return "EPS";
        case "MP3":
        case "WAV":
            return "AUDIO";
        default:
            return "UNKNOWN";
    }
};
